"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendConversationalSearchResultsEvent = exports.PhoenixEventMetadata = void 0;
var _uuid = require("uuid");
var _sharedFunctions = require("./sharedFunctions");
var _TccConstants = require("./constants/TccConstants");
var _traffic = require("./traffic");
var _UrlHelper = require("./UrlHelper");
class PhoenixEventMetadata {
  #searchGuid = '';
  #searchNumber = 0;
  get searchGuid() {
    return this.#searchGuid;
  }
  set searchGuid(searchGuid) {
    this.#searchGuid = searchGuid;
  }
  get searchNumber() {
    return this.#searchNumber;
  }
  set searchNumber(searchNumber) {
    this.#searchNumber = searchNumber;
  }
  getEventSent(eventSent) {
    return this[eventSent] || false;
  }
  setEventSent(eventSent, value) {
    this[eventSent] = value;
  }
}

/**
 * @description Builds the event schema.
 * @param {string} apiKey Tcc api Key
 * @param {string} schemaId schema Id
 * @param {array} events events array
 * @returns {{schema: string, data: {apiKey, schemaId, events}, version: string}} event schema
 */
exports.PhoenixEventMetadata = PhoenixEventMetadata;
const buildEventSchema = ({
  apiKey,
  schemaId,
  events
}) => {
  return {
    schema: 'add_micro_events',
    version: 'v1',
    data: {
      apiKey,
      schemaId,
      events
    }
  };
};

/**
 * @description Fires the conversational search results Phoenix Event.
 * @param {string} searchQuery search query
 * @param {string} source apiKey / appName / unique identifier for the consumer of the component.
 * @param {string} tmsKey tms key
 * @param {object} spinsResponse spins response
 * @param {string} currency currency code
 * @param {set} allFavorites set of all favorited domains
 * @param {object} phoenixEventMetadataObj object of PhoenixEventMetadata
 * @param {object} tccApiKeys tcc api keys for dev, test and prod
 */
// eslint-disable-next-line complexity
const sendConversationalSearchResultsEvent = ({
  searchQuery,
  source,
  tmsKey = '',
  spinsResponse,
  currency,
  allFavorites = new Set([]),
  phoenixEventMetadataObj,
  tccApiKeys = {}
}) => {
  if (!phoenixEventMetadataObj.getEventSent('isConversationalSearchEventSent')) {
    phoenixEventMetadataObj.setEventSent('isConversationalSearchEventSent', true);
    const spins = spinsResponse?.RecommendedDomains || [];
    const caasId = spinsResponse?.CaasId || '';
    const products = spinsResponse?.Products || [];
    const {
      isc,
      itc
    } = (0, _UrlHelper.getIscAndItc)();
    phoenixEventMetadataObj.searchGuid = (0, _uuid.v4)();
    if (searchQuery) {
      phoenixEventMetadataObj.searchNumber = phoenixEventMetadataObj.searchNumber + 1;
    }
    const aiResultItems = spins.map((spin, index) => {
      const productInfo = products.filter(item => item?.ProductId === spin.ProductId)?.[0];
      const favoritedFlag = allFavorites.has(spin?.Fqdn);
      const sponsorshipType = spin.IsAd ? 'paid' : 'organic';
      const availabilityType = (0, _sharedFunctions.getSpinAvailabilityType)(spin);
      const domain = {
        ...spin,
        isAftermarketPremium: (0, _sharedFunctions.isAftermarketPremium)(spin),
        isAuction: (0, _sharedFunctions.isAuction)(spin),
        isRegPremium: (0, _sharedFunctions.isRegPremium)(spin)
      };
      return {
        position: `spins_${index + 1}`,
        availabilityType,
        domainName: spin?.Fqdn,
        price: productInfo?.PriceInfo?.TotalCurrentPrice || 0,
        tld: spin?.Extension,
        favoritedFlag,
        sponsorshipType,
        domainGuid: domain?.DomainGUID
      };
    });
    const conversationalSearchResultsEvent = {
      schemaId: _TccConstants.CONVERSATIONAL_SEARCH_RESULTS_EVENT_SCHEMA_ID,
      data: {
        searchQuery,
        searchGuid: phoenixEventMetadataObj.searchGuid,
        searchNumber: phoenixEventMetadataObj.searchNumber,
        source,
        currencyCode: currency,
        tmsKey,
        itcOverride: itc,
        caasId,
        discountCode: isc,
        aiResults: aiResultItems
      }
    };
    if (searchQuery && window.Cypress && window.phoenixEvents) {
      window.phoenixEvents.conversationalSearchResultsEvent?.push(conversationalSearchResultsEvent);
    }
    (0, _traffic.logSignalEvent)(buildEventSchema({
      apiKey: tccApiKeys[(0, _UrlHelper.getEnv)(window.location.href)],
      schemaId: _TccConstants.BASE_EVENT_SCHEMA_ID,
      events: [conversationalSearchResultsEvent]
    }));
  }
};
exports.sendConversationalSearchResultsEvent = sendConversationalSearchResultsEvent;